import Agreement from './Agreement';

export default Agreement;
